export function refresh(grid) {
  grid.gridView.refresh(true);
}

export function getSortInfo(grid) {
  const { name, directionIndex } = grid.gridView.get('sortableHeader') || {};

  if (name) {
    const column = grid.gridView.columnWithName(name);

    // The sortable column in preference might not be selected in the current grid view.
    if (column) {
      const sortedKey = column.sortable.key;

      return directionIndex < 0 ? `${sortedKey} desc` : sortedKey;
    }
  }
  return null;
}

export function isCrossPageAllSelected(grid) {
  return grid.pgridPlugins.crossPageSelectAll.isAllSelected;
}

export function getSelectedRowIds(grid) {
  if (grid) {
    return grid.gridView.selectedKeys();
  }
  return [];
}

export function getSelectedRowsCount(grid) {
  return isCrossPageAllSelected(grid) ?
    grid.gridView.totalCountRows :
    getSelectedRowIds(grid).length;
}
